module.exports = __webpack_public_path__ + "static/mobileBank2-7813898c4a8059e06c55a908218afcc7.png";